import { render } from "./ModalEditOriInfo.vue?vue&type=template&id=e472b62e&scoped=true"
import script from "./ModalEditOriInfo.vue?vue&type=script&lang=js"
export * from "./ModalEditOriInfo.vue?vue&type=script&lang=js"

import "./ModalEditOriInfo.vue?vue&type=style&index=0&id=e472b62e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e472b62e"]])

export default __exports__